import { api } from "@api/api";
import { ApiResponse } from "@shared/types";
import { IntegrationEndpointOption } from "@modules/erpIntegrations/types";

import { ListIntegrationEndpointsQueryFilters } from "./types";

export async function getIntegrationEndpointsService(
  filters: ListIntegrationEndpointsQueryFilters
): Promise<IntegrationEndpointOption[]> {
  const { data } = await api.get<ApiResponse<IntegrationEndpointOption>>(
    "/v1/integration_endpoint_admin/",
    {
      params: {
        integration: filters.integration,
        page: filters.page,
        page_size: filters.perPage ?? 100,
      },
    }
  );

  return data.results;
}
